import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-f480fa5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Themes"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "engagement-trending-info",
    class: "title"
  }, [
    /*#__PURE__*/_createTextVNode(" Engagement "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Info icon"
    })
  ])
], -1))
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InsightsEngagementThemeItem = _resolveComponent("InsightsEngagementThemeItem")!
  const _component_InsightsListLoading = _resolveComponent("InsightsListLoading")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$isMobile ? 'GradientHighlightedCard' : 'BaseCard'), null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["insight-engagement-trending-list-card", {
                'desktop-insight-engagement-trending-list-card': !_ctx.$isMobile,
            }])
      }, [
        _hoisted_1,
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themes, (theme, i) => {
                return (_openBlock(), _createBlock(_component_InsightsEngagementThemeItem, {
                  key: theme.id,
                  "theme-id": theme.id,
                  title: theme.name,
                  history: theme.history,
                  points: theme.change_in_term_data.score,
                  "overall-score": theme.current_term_data.score,
                  "previous-score": theme.previous_term_data.score,
                  "delta-positive": theme.change_in_term_data.score > 0,
                  class: _normalizeClass([
                        i + 1 < _ctx.themes.length &&
                        theme.id !== _ctx.desktopEngagementThemeSelected &&
                        _ctx.currentPosition !== i + 1
                            ? 'bottom-border'
                            : 'no-border',
                    ]),
                  onClick: ($event: any) => (_ctx.onClickTheme(theme, i))
                }, null, 8, ["theme-id", "title", "history", "points", "overall-score", "previous-score", "delta-positive", "class", "onClick"]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_InsightsListLoading, { key: 1 }))
      ], 2)
    ], undefined, true),
    _: 1
  }))
}